import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '@/components/ui';

interface NewProps {
    onIssue: () => void;
    canIssue: boolean;
}

/**
 * EAA-1820 (frame 33): realm/search genuinely has zero accounts.
 *
 * EAA-1804: action buttons swapped to the kit `Button` instead of
 * hand-written `<button className="portal-btn ...">`.
 */
export function AccountsEmptyNew({ onIssue, canIssue }: NewProps) {
    const { t } = useTranslation();
    return (
        // EAA-1804: root debugging handle, matching the folder's existing acc-* prefix.
        <EmptyState
            className="acc-empty-new"
            title={t('console.accounts.emptyState.newTitle')}
            description={t('console.accounts.emptyState.newDescription')}
            action={
                canIssue ? (
                    <Button type="primary" onClick={onIssue}>
                        {t('console.accounts.emptyState.issueButton')}
                    </Button>
                ) : undefined
            }
        />
    );
}

interface FilteredProps {
    search: string;
    onClear: () => void;
}

/** EAA-1820 (frame 33): a search/filter combination matched nothing — this is
 *  a DIFFERENT state from `AccountsEmptyNew` and offers a different action
 *  (clear the filter, not create an account), per the ticket's brief. */
export function AccountsEmptyFiltered({ search, onClear }: FilteredProps) {
    const { t } = useTranslation();
    return (
        // EAA-1804: root debugging handle, matching the folder's existing acc-* prefix.
        <EmptyState
            className="acc-empty-filtered"
            title={t('console.accounts.emptyState.filteredTitle')}
            description={
                search
                    ? t('console.accounts.emptyState.filteredDescriptionWithSearch', { search })
                    : t('console.accounts.emptyState.filteredDescription')
            }
            action={
                <Button onClick={onClear}>
                    {t('console.accounts.emptyState.clearFiltersButton')}
                </Button>
            }
        />
    );
}
